import { RangeValue } from "@rentablo/components";
import { useHistoricQuoteLookupPerYear } from "../useHistoricQuotesLookup";
import { useChartDataBase } from "./useChartDataBase";
import { mergeHistoricQuotes } from "./mergeHistoricQuotes";
import { getDates } from "./getFromDate";

interface Props {
  isin?: string;
  quoteProvider?: string;
  tickerSymbol?: string;
  range?: RangeValue;
  dataKey1?: string;
  dataKey2?: string;
}
interface Options {
  enabled?: boolean;
}

export const useChartData = (
  { isin, quoteProvider, tickerSymbol, range, dataKey1, dataKey2 }: Props,
  { enabled }: Options = { enabled: true }
) => {
  const { fromDate } = getDates(range);

  const {
    data: historicQuotes,
    isFetching: historicQuotesIsLoading,
    isPending: historicQuotesIsPending,
  } = useHistoricQuoteLookupPerYear(quoteProvider, tickerSymbol, fromDate, {
    enabled,
  });

  const {
    data: chartData,
    securityData,
    isFetching: isChartDataLoading,
    isPending: isChartDataPending,
  } = useChartDataBase(
    {
      isin,
      range,
    },
    { enabled }
  );

  const isFetching = isChartDataLoading || historicQuotesIsLoading;
  const isPending = isChartDataPending || historicQuotesIsPending;

  const data = mergeHistoricQuotes(chartData, historicQuotes);

  return {
    data,
    securityData,
    isFetching,
    isPending,
  };
};
